const additionalRoutes: Record<string, string[]> = {
  '/results': ['^/workspace(/.*)*$'],
  '/vltl-ltl-rates': ['/discover/vltl-ltl-rates'],
};

export default function isRouteActive(currentPathname: string, url: string) {
  if (currentPathname.includes('/results/')) {
    return currentPathname.includes('/dashboard')
      ? url.includes('/dashboard')
      : currentPathname.includes(url);
  }

  const match = `${currentPathname}/`.includes(`${url}/`);

  if (match) {
    return true;
  }

  if (additionalRoutes[url]) {
    return additionalRoutes[url].some((pattern) =>
      currentPathname.match(pattern),
    );
  }

  return false;
}
